var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    width: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34314 1.34315 0 3 0H53C54.6569 0 56 1.34315 56 3V53C56 54.6569 54.6569 56 53 56H3C1.34314 56 0 54.6569 0 53V3Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5416 41.3333H14.4583C12.7323 41.3333 11.3333 39.9342 11.3333 38.2083V19.4583C11.3333 17.7324 12.7323 16.3333 14.4583 16.3333H41.5416C43.2675 16.3333 44.6666 17.7324 44.6666 19.4583V38.2083C44.6666 39.9342 43.2675 41.3333 41.5416 41.3333ZM18.6249 19.9792C16.6114 19.9792 14.9791 21.6115 14.9791 23.625C14.9791 25.6385 16.6114 27.2708 18.6249 27.2708C20.6385 27.2708 22.2708 25.6385 22.2708 23.625C22.2708 21.6115 20.6385 19.9792 18.6249 19.9792ZM15.4999 37.1667H40.4999V29.875L34.8023 24.1774C34.4973 23.8723 34.0026 23.8723 33.6974 24.1774L24.8749 33L21.2607 29.3857C20.9556 29.0807 20.4609 29.0807 20.1558 29.3857L15.4999 34.0417V37.1667Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default-icon.7f9e129f2169a9b923cb3adcac951adc.svg";
export { ForwardRef as ReactComponent };